import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkDisallowScreenshare } from 'features/permissions/actions';

export function* bulkDisallowScreenshareSaga(action: ReturnType<typeof bulkDisallowScreenshare>) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk disallowed screenshare for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkDisallowScreenshare',
    data: { roles },
  });
}
